<ng-container *transloco="let t; read: 'forgotPassword'">
  @if (isDXP$ | async) {
    <div data-test-id="forgot-password-background-wrapper" class="background">
      <img
        data-test-id="forgot-password-background"
        src="/assets/dxp/img/background.png"
        alt=""
        srcset=""
      />
    </div>
  }

  @if (!(useNewNav$ | async)) {
    <app-header data-test-id="forgot-password-header" [showDropdown]="false"></app-header>
  }
  @if (showSpin) {
    <div data-test-id="forgot-password-container" class="container">
      <p data-test-id="forgot-password-container-text-center" class="text-center pt-5 pb-2">
        <img
          data-test-id="forgot-password-spinner"
          src="assets/images/spinner.gif"
          alt="spinner"
          class="img-fluid spinner d-inline"
        />
      </p>
    </div>
  }

  @if (!showSpin && !showForm) {
    <div data-test-id="forgot-password-container" class="container">
      @if (useNewNav$ | async) {
        <div data-test-id="forgot-password-syn-container" class="syn-container">
          <h2 data-test-id="forgot-password-invalid-link-text">{{ t('invalidLinkText') }}</h2>
          <button
            data-test-id="forgot-password-redirect-to-contact-synlab"
            (click)="redirectToContactSynlab()"
          >
            <mat-icon aria-hidden="true" data-test-id="forgot-password-arrow-forward">arrow_forward</mat-icon>
            {{ 'completeProfile.openUefaLink' | transloco }}
          </button>
        </div>
      } @else {
        <div
          data-test-id="forgot-password-alert-warning"
          class="alert alert-warning mt-5"
          role="alert"
        >
          {{ t('invalidLinkText') }}
        </div>
      }
    </div>
  }

  @if (!showSpin && showForm) {
    <div
      data-test-id="forgot-password-shfy-container"
      [ngClass]="{ 'is-dxp': (isDXP$ | async) }"
      class="container pt-5 pb-5"
    >
      <div data-test-id="forgot-password-shfy-row" class="row">
        <div data-test-id="forgot-password-shfy-column" class="col-12 col-sm-12">
          <div
            data-test-id="forgot-password-profile-secure-wrappper"
            class="card profile-secure-wrappper pl-box-shadow-1"
          >
            <div data-test-id="forgot-password-card-body" class="card-body pb-5 p-0">
              <h3
                data-test-id="forgot-password-reset-your-password-title"
                class="title-mb f-6 py-3 px-4"
              >
                {{ t('resetYourPasswordTitle') }}
              </h3>
              @if (loading) {
                <p
                  data-test-id="forgot-password-loading-wrapper"
                  class="text-center pt-5 pb-2 mb-5"
                >
                  <img
                    data-test-id="forgot-password-loading-spinner"
                    src="assets/images/spinner.gif"
                    alt="spinner"
                    class="img-fluid spinner d-inline"
                  />
                </p>
              }
              @if (!loading) {
                <div data-test-id="forgot-password-alert-wrapper" class="wrapper py-3 px-4">
                  <div
                    data-test-id="forgot-password-alert-danger"
                    class="alert alert-danger"
                    role="alert"
                    hidden
                  >
                    <p data-test-id="forgot-password-alert-content" class="text-center">
                      <strong data-test-id="forgot-password-note-text">{{ t('noteText') }}:</strong>
                      <br />
                      {{ t('completeRegistrationText.text1') }}
                      <br />
                      {{ t('completeRegistrationText.text2') }}
                    </p>
                  </div>
                  <!-- Account Password -->
                  <div data-test-id="forgot-password-row" class="row">
                    <div data-test-id="forgot-password-column" class="col-12 col-sm-12">
                      <form
                        data-test-id="forgot-password-password-form"
                        autocomplete="off"
                        [formGroup]="passwordFormG"
                        (ngSubmit)="setAccountPassword()"
                      >
                        @if (passwordFormG; as fp) {
                          <div
                            data-test-id="forgot-password-password-form-centered"
                            class="row justify-content-center"
                          >
                            <div
                              data-test-id="forgot-password-form-groups-wrapper"
                              class="col-12 col-sm-9 pt-4"
                            >
                              @if (isDXP$ | async) {
                                <ng-container *ngTemplateOutlet="passwordHelpBlock"></ng-container>
                              }
                              <!-- new password -->
                              <div data-test-id="forgot-password-form-group" class="form-group">
                                @if ((isDXP$ | async) === false) {
                                  <label
                                    data-test-id="forgot-password-form-group-label"
                                    class="f-2"
                                    [for]="EPassForm.NEW_PASS"
                                    >{{ t('enterPasswordLabel') }}</label
                                  >
                                }
                                <input
                                  data-test-id="forgot-password-form-group-control"
                                  type="password"
                                  class="form-control"
                                  [formControlName]="EPassForm.NEW_PASS"
                                  [id]="EPassForm.NEW_PASS"
                                  [ngClass]="{
                                    'border-danger':
                                      fp.get(EPassForm.NEW_PASS).errors &&
                                      fp.get(EPassForm.NEW_PASS).dirty,
                                  }"
                                  [placeholder]="(isDXP$ | async) ? t('enterPasswordLabel') : ''"
                                />
                              </div>
                              <!-- confirm password -->
                              <div data-test-id="forgot-password-form-group" class="form-group">
                                @if ((isDXP$ | async) === false) {
                                  <label
                                    data-test-id="forgot-password-form-group-label"
                                    class="f-2"
                                    [for]="EPassForm.CONFIRM_PASS"
                                    >{{ t('confirmPasswordLabel') }}</label
                                  >
                                }
                                <input aria-describedby="forgot-password-error" [attr.aria-invalid]="!!(fp.errors?.confirmPassword)"
                                  data-test-id="forgot-password-form-group-control"
                                  type="password"
                                  class="form-control"
                                  [formControlName]="EPassForm.CONFIRM_PASS"
                                  [id]="EPassForm.CONFIRM_PASS"
                                  [ngClass]="{
                                    'border-danger':
                                      (fp.errors?.confirmPassword &&
                                        fp.get(EPassForm.CONFIRM_PASS).dirty) ||
                                      (fp.get(EPassForm.CONFIRM_PASS).invalid &&
                                        fp.get(EPassForm.CONFIRM_PASS).dirty),
                                  }"
                                  [placeholder]="(isDXP$ | async) ? t('confirmPasswordLabel') : ''"
                                />
                                @if (fp.errors?.confirmPassword) {
                                  <small id="forgot-password-error" data-test-id="forgot-password-error" class="text-danger">
                                    {{ t('passwordDontMatchError') }}
                                  </small>
                                }
                                @if ((isDXP$ | async) === false) {
                                  <ng-container
                                    *ngTemplateOutlet="passwordHelpBlock"
                                  ></ng-container>
                                }
                              </div>
                              <!-- submit button -->
                              <div data-test-id="forgot-password-btns-wrapper" class="buttons mt-4">
                                <button
                                  data-test-id="forgot-password-save-pass-btn"
                                  [disabled]="fp.invalid"
                                  id="save_pass_button"
                                  class="btn btn-primary px-4 float-right"
                                  type="submit"
                                >
                                  @if (isDXP$ | async) {
                                    <i
                                      data-test-id="forgot-password-forgot-password-btn-icon"
                                      class="fa fa-arrow-right forgot-password-btn-icon"
                                      aria-hidden="true"
                                    ></i>
                                  }
                                  {{ t('savePasswordButton') }}
                                </button>
                                <span
                                  data-test-id="forgot-password-clearfix"
                                  class="clearfix"
                                ></span>
                              </div>
                            </div>
                          </div>
                        }
                      </form>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <ng-template #passwordHelpBlock>
    <small
      data-test-id="forgot-password-password-help-block"
      id="passwordHelpBlock"
      class="form-text pt-2 text-muted"
    >
      {{ t('passwordInstructionText') }}
    </small>
  </ng-template>
</ng-container>
